var React = require('react');

function IconCartInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"fill":"currentColor","d":"M20.34 13.6l1.64-7.32a.84.84 0 00-.81-1.03H7.53L7.2 3.67A.84.84 0 006.39 3H2.83a.84.84 0 00-.83.84v.57c0 .46.37.84.83.84h2.43L7.7 17.32A1.97 1.97 0 008.67 21a1.97 1.97 0 001.36-3.38h7.28A1.97 1.97 0 0018.67 21c1.07 0 1.94-.88 1.94-1.97 0-.78-.45-1.45-1.1-1.77l.2-.85a.84.84 0 00-.82-1.04H9.57l-.22-1.12h10.17c.4 0 .73-.27.82-.66z","id":"icon_cart_inline"})),React.createElement("use",{"transform":"matrix(-1 0 0 1 22 -3)","xlinkHref":"#icon_cart_inline","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

IconCartInline.defaultProps = {"viewBox":"0 0 20 18"};

module.exports = IconCartInline;

IconCartInline.default = IconCartInline;
